import { useIntl } from 'react-intl';

import BRBilingualInput from 'components/BRBilingualInput/BRBilingualInput';
import URLField from 'components/Pages/components/CreateEditPage/components/URLField/URLField';

const PageDetailsSection = ({ formRef, urlName, fetchPageDetails }) => {
  const { formatMessage } = useIntl();

  return (
    <div className="br-page-details-section br-create-edit-page-card">
      <div className="br-create-edit-page-card__title">
        {formatMessage({
          id: 'pages.create_edit_page.page_details.title'
        })}
      </div>
      <div className="br-create-edit-page-card__content">
        <BRBilingualInput
          type="text"
          formRef={formRef}
          name={{
            EN: 'pageTitle',
            AR: 'pageTitleAr'
          }}
          inputTitle={formatMessage({
            id: 'pages.create_edit_page.form.title_field.label'
          })}
          placeholderId="pages.create_edit_page.form.title_field.placeholder"
          rules={[
            {
              required: true,
              whitespace: true,
              message: formatMessage({
                id: 'pages.create_edit_page.form.title_field.error_msgs.required'
              })
            }
          ]}
          subtitle={formatMessage({
            id: 'pages.create_edit_page.form.title_field.hint'
          })}
          showSubTittle
          hasFeedback
        />
        <BRBilingualInput
          type="text"
          formRef={formRef}
          name={{
            EN: 'description',
            AR: 'descriptionAr'
          }}
          inputTitle={formatMessage({
            id: 'pages.create_edit_page.form.description_field.label'
          })}
          placeholderId="pages.create_edit_page.form.description_field.placeholder"
          rules={[
            {
              required: true,
              whitespace: true,
              message: formatMessage({
                id: 'pages.create_edit_page.form.description_field.error_msgs.required'
              })
            }
          ]}
          hasFeedback
          isTextArea
        />
        <URLField
          formRef={formRef}
          urlName={urlName}
          fetchPageDetailsURL={fetchPageDetails?.url}
        />
      </div>
    </div>
  );
};

export default PageDetailsSection;
